//import geojsonhint from '@mapbox/geojsonhint';

import gjv from 'geojson-validation';

class DatasetUtils {

    static unsetGeometryFeatures(fields) {
        let GEOMETRY_FEATURES = {
            /*x: "X центра",
            y: "Y центра",*/
            Geometry: "Геометрия"
        };
        return DatasetUtils.unsetFeatures(fields, GEOMETRY_FEATURES);
    }

    static unsetAddressFeatures(fields) {
        let ADDRESS_FEATURES = {
            Region: "Регион",
            Municipalitet: "Населенный пункт",
            Street: "Улица",
            HouseNumber: "Номер дома"
        };
        return DatasetUtils.unsetFeatures(fields, ADDRESS_FEATURES);
    }

    static unsetConnectingFeatures(fields) {
        let CONNECTING_FEATURES = {
            ID: "Идентификатор",
            Address: "Адрес полностью",
            Region: "Регион",
            Municipalitet: "Населенный пункт",
            Street: "Улица",
            HouseNumber: "Номер дома",
            x: "X центра",
            y: "Y центра",
            Geometry: "Геометрия"
        };
        return DatasetUtils.unsetFeatures(fields, CONNECTING_FEATURES);
    }

    static unsetConnectingByGeometryFeatures(fields) {
        let CONNECTING_FEATURES = {
            ID: "Идентификатор",
            x: "X центра",
            y: "Y центра"
        };
        return DatasetUtils.unsetFeatures(fields, CONNECTING_FEATURES);
    }

    static unsetConnectingByAddressFeatures(fields) {
        let CONNECTING_FEATURES = {
            ID: "Идентификатор",
            Region: "Регион",
            Municipalitet: "Населенный пункт",
            Street: "Улица",
            HouseNumber: "Номер дома"
        };
        return DatasetUtils.unsetFeatures(fields, CONNECTING_FEATURES);
    }

    static unsetFeatures(fields, featuresObject) {
        let unsetFeatures = [];
        Object.entries(featuresObject).map((featureArray) => {
            let exists = false;
            for (let j = 0; j < fields.length; j++) {
                if (fields[j].feature === featureArray[0]) {
                    exists = true;
                }
            }
            if (!exists) {
                unsetFeatures.push(featureArray[1]);
            }
        });
        return unsetFeatures;
    }

    static getNameProgress = (type) => {
        let name;
        switch (type) {
            case 'lk_importer':
                name = 'импорт';
                break;
            case 'lk_geometrytransformer':
                name = 'трансформация геометрии';
                break;
            case 'lk_decomposer':
                name = 'разбор адреса';
                break;
            case 'lk_normalizer':
                name = 'процесс нормализации';
                break;
            case 'lk_publisher':
                name = 'процесс публикации';
                break;
            case 'lk_connector':
                name = 'процесс связывания';
                break;
            case 'lk_exporter':
                name = 'экспорт в файл';
                break;
            default:
                console.log("ошибка процесса");
        }
        return name;
    }

    static getGeometryInfo = (geometry) => {
        if (!geometry) {
            return '-';
        }
        //TODO: красивые склонения числительных
        let info;
        let geometryValidation = gjv.isGeometryObject(geometry);

        switch (geometry.type) {
            case 'Point':
                info = 'Точка';
                if (!geometryValidation) { info = "НЕВАЛИДНАЯ " + info }
                break;
            case 'MultiPoint':
                info = 'Мультиточка';
                if (geometry.coordinates) {
                    info += ', ' + geometry.coordinates.length + ' шт'
                }
                if (!geometryValidation) { info = "НЕВАЛИДНАЯ " + info }
                break;
            case 'LineString':
                info = 'Линия';
                if (geometry.coordinates) {
                    info += ', ' + geometry.coordinates.length + ' точек'
                }
                if (!geometryValidation) { info = "НЕВАЛИДНАЯ " + info }
                break;
            case 'MultiLineString':
                info = 'Мультилиния';
                if (geometry.coordinates) {
                    let points = 0;
                    geometry.coordinates.forEach((line) => {
                        points += line.length;
                    });
                    info += ', ' + geometry.coordinates.length + ' шт'
                    info += ', ' + points + ' точек';
                }
                if (!geometryValidation) { info = "НЕВАЛИДНАЯ " + info }
                break;
            case 'Polygon':
                info = 'Полигон';
                if (geometry.coordinates) {
                    let points = 0;
                    geometry.coordinates.forEach((contour) => {
                        points += (contour.length - 1);
                    });
                    if (geometry.coordinates.length > 1) {
                        info += ', ' + (geometry.coordinates.length - 1) + ' дырок'
                    }
                    info += ', ' + points + ' точек';
                }
                if (!geometryValidation) { info = "НЕВАЛИДНЫЙ " + info }
                break;
            case 'MultiPolygon':
                info = 'Мультиполигон';
                if (geometry.coordinates) {
                    let points = 0;
                    geometry.coordinates.forEach((polygon) => {
                        polygon.forEach((contour) => {
                            points += (contour.length - 1);
                        });
                    });
                    info += ', ' + geometry.coordinates.length + ' частей'
                    info += ', ' + points + ' точек';
                }
                if (!geometryValidation) { info = "НЕВАЛИДНЫЙ " + info }
                break;
            case 'GeometryCollection':
                info = 'Коллекция геометрий (мусор)';
                if (!geometryValidation) { info = "НЕВАЛИДНАЯ " + info }
                break;
            default:
                info = "Неизвестный тип";
        }
        return info;
    }

}

export default DatasetUtils;